import React, { useState } from "react";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";

const MapContainer2 = ({ devices, maxHeight, maxWidth }) => {
  const [selectedDevice, setSelectedDevice] = useState(null);

  const containerStyle = {
    width: maxWidth || "100%",
    height: maxHeight || "80vh",
  };

  function parseTimestamp(timestamp) {
    try {
      const [datePart, timePart] = timestamp.split(" ");
      const [day, month, year] = datePart.split("/").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);
      return new Date(year, month - 1, day, hour, minute, second);
    } catch (e) {
      return new Date();
    }
  }

 // const center = { lat: 31.2961, lng: 34.7516 };
  const [mapCenter] = useState({ lat: 31.2961, lng: 34.7516 });

  const getMarkerIcon = (isOnline) => ({
    url: isOnline
      ? "/hamitaher/assets/online.png"
      : "/hamitaher/assets/offline.png",
    scaledSize: { width: 32, height: 32 },
    anchor: { x: 16, y: 32 },
  });
  const navigate = useNavigate();
  function spreadMarkers(devices) {
    const coordinateMap = {};
  
    // Count occurrences by "lat,lng"
    devices.forEach((d) => {
      const key = `${d.latitude},${d.longitude}`;
      coordinateMap[key] = (coordinateMap[key] || 0) + 1;
    });
  
    // Apply offset to duplicates
    const updated = {};
    return devices.map((d) => {
      const key = `${d.latitude},${d.longitude}`;
  
      if (coordinateMap[key] > 1) {
        const index = updated[key] || 0;
        updated[key] = index + 1;
  
        const offset = 0.0003 * index; // small movement (≈ 11 meters)
        return {
          ...d,
          latitude: Number(d.latitude) + offset,
          longitude: Number(d.longitude) + offset,
        };
      }
  
      return d;
    });
  }
  return (
    <LoadScript googleMapsApiKey="AIzaSyBajhVyi8KbuKuEPk1osx9M_7qmpg8e1-c">
      <GoogleMap mapContainerStyle={containerStyle} zoom={9} center={mapCenter}
       options={{
        gestureHandling: "greedy", // enables full movement
        draggable: true,           // allow drag
        zoomControl: true,
        fullscreenControl: true,
        }}>
        
        {spreadMarkers(devices).map((device, index) => {
          const currentTime =
            new Date().getTime() + new Date().getTimezoneOffset() * 60000;

          if (!device.heartbeat) return null;
if(!(device?.deviceInfo?.devices || "{}")[device.id]
?.provisioned) return null;
          const date = parseTimestamp(device.heartbeat);
          if (isNaN(date.getTime())) return null;

          const lastHeartbeat = date.getTime();
          const timeDifference = (currentTime - lastHeartbeat) / 1000;

          const isOnline = timeDifference <= 10;
          const lat = Number(device.latitude);
          const lng = Number(device.longitude);
         
          // if(device.id == "DB2SG-XUQNKMX6"){
          //   console.log(!lat , !lng , lat === 0 , lng === 0, parseFloat(lat) === 0.0 , parseInt(lng) === 0.0 , isNaN(lat) , isNaN(lng))
          //   console.log(lat,lng)
          // }
          // Skip markers with invalid or 0 coordinates
          if (!lat || !lng || lat === 0 || lng === 0|| parseFloat(lat) === 0.0 || parseFloat(lng) === 0.0 || isNaN(lat) || isNaN(lng)) {
            return null;
          }
          
          const markerPosition = {
            lat,
            lng,
          };
// Shift markers that have same lat/lng


          return (
            <Marker
              key={index}
              position={markerPosition}
              icon={getMarkerIcon(isOnline)}
              // onClick={() => setSelectedDevice({ ...device, isOnline })}
              onClick={()=>{
                setSelectedDevice({ ...device, isOnline });
              
              }}
            />
          );
        })}

        {/* ---------- INFO WINDOW ---------- */}
        {selectedDevice && (
          <InfoWindow
            position={{
              lat: Number(selectedDevice.latitude),
              lng: Number(selectedDevice.longitude),
            }}
            
            onCloseClick={() => setSelectedDevice(null)}
          >
            <div onClick={()=>{
              if ((selectedDevice?.deviceInfo?.devices || "{}")[selectedDevice.id]?.provisioned) {
                navigate("/devicesdata", {
                  state: {
                    deviceName: selectedDevice.deviceName,
                    enabled: (selectedDevice?.deviceInfo?.devices || "{}")[selectedDevice.id]
                      ?.enabled,
                    esp_id: selectedDevice.id,
                    provisioned: (selectedDevice?.deviceInfo?.devices || "{}")[selectedDevice.id]
                      ?.provisioned,
                    user: selectedDevice.deviceInfo,
                  },
                });
              } else {
                console.log(selectedDevice.id)
                alert(
                  "Device not provisioned: First provision it from the app"
                );
              }
            }} style={{ width: "220px",cursor:"pointer" }}>
              <h4 style={{ margin: "0", color: "#AE8625" }}>
                {selectedDevice.deviceName || "Device"}
              </h4>

              <p style={{ margin: "5px 0" }}>
                <strong>ID:</strong> {selectedDevice.id}
              </p>

              <p style={{ margin: "5px 0" }}>
                <strong>User:</strong> {selectedDevice.user || "Unknown"}
              </p>

              <p style={{ margin: "5px 0" }}>
                <strong>Version:</strong> {selectedDevice.version}
              </p>

              {/* <p style={{ margin: "5px 0" }}>
                <strong>Installed:</strong> {selectedDevice.installation_date}
              </p> */}

              <p
                style={{
                  margin: "10px 0 0",
                  fontWeight: "bold",
                  color: selectedDevice.isOnline ? "#28a745" : "#dc3545",
                }}
              >
                ● {selectedDevice.isOnline ? "Online" : "Offline"}
              </p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapContainer2;
